<template>
  <div :class="`modal ${isModalActive ? 'is-active' : ''}`">
    <div class="modal-background"></div>
    <div class="modal-card" :class="`${changeWidthModal ? 'modal-card-personalizado' : ''}`">
      <header class="modal-card-head">
        <p class="modal-card-title" :id="idModal">{{ titulo }}</p>
        <button
          id="btn-fechar-modal"
          class="delete"
          aria-label="close"
          data-cy="btn-fechar-modal"
          @click="$emit('close')"
        ></button>
      </header>
      <section class="modal-card-body">
        <slot />
      </section>
      <footer class="modal-card-foot">
        <TrfCheckbox
          v-if="usuarioTemPermissaoDeCriacaoDeModelo && isAvulsa && !modalPermissaoAtivo"
          label="Criar novo modelo"
          id="checkbox-novo-modelo"
          v-model="isSelectCriarModeloNovo"
          @change="emitCheckBoxValue"
          :tituloTip="tituloTipModelo"
          class="checkbox-novo-modelo"
        />
        <button
          class="button is-primary"
          :class="{ 'is-loading': isBtnLoading }"
          type="submit"
          id="btn-cadastrar-nova-tarefa"
          data-cy="btn-submit"
          :disabled="isBtnOkDisabled"
          @click="$emit('save')"
        >
          {{ this.btnSaveName }}
        </button>
        <button 
          class="button" 
          :disabled="isBtnCancelDisabled" 
          @click="$emit('close')" 
          id="btn-cancelar-cadastro-tarefa"
          data-cy="btn-close"
        >
            {{ this.btnCloseName }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import TrfCheckbox from '../Checkbox'
export default {
  name: "TrfModal",
  components: {
    TrfCheckbox
  },
  data() {
    return {
      isSelectCriarModeloNovo: false
    };
  },
  emits: ['close', 'save'],
  props: {
    titulo: String,
    isBtnOkDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    isBtnCancelDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    isModalActive: {
      type: Boolean,
      default: true,
    },
    isBtnLoading: Boolean,
    idModal: String,
    btnSaveName: {
      type: String,
      default: "Cadastrar",
    },
    btnCloseName: {
      type: String,
      default: "Cancelar",
    },
    changeWidthModal: {
      type: Boolean,
      default: false
    },
    usuarioTemPermissaoDeCriacaoDeModelo: {
      type: Boolean,
      default: false
    },
    isAvulsa: {
      type: Boolean,
      default: false
    },
    modalPermissaoAtivo: {
      type: Boolean,
      default: false
    },
    tituloTipModelo: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    emitCheckBoxValue() {
      this.$emit('isModeloNovoSelected',this.isSelectCriarModeloNovo)
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card-head {
  padding: 15px 15px 15px 35px;
}

.modal-card-title {
  font-size: 18px;
  line-height: 1.42857143;
}

.modal-card-body {
  padding: 8px 35px;
}

.modal-card-foot {
  justify-content: flex-end;
  padding: 15px;
  align-items: center;
}

.checkbox-novo-modelo {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

@media screen and (min-width: 769px){
 .modal-card.modal-card-personalizado{
    width: 500px;
 }
}
</style>
